import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const JUNE_2025_CAMPAIGN_END_DATE = d(2025, 6, 23, 0, 0);
